import { SelectOption } from '@globaleris/ui.library'
import { SubjectTableModel } from '../../clients/clients.model'
import { ContractModel } from '../../../api/Argentia/model/contracts'
import { ContractProductAPIModel } from '../../../api/Pioneer/model/Contracts'
import { CommercialFormModel } from './commercials.details'
import {
  CommercialModel,
  NewCommercialModel
} from '../../../api/Argentia/model/commercials/commercial'
import { EnumCommercialRelationActionType } from '../../../api/oData/enums/enumCommercialRelationActionType'
import { enumEnumToValueNumber, enumEnumToValueString } from '../../../helpers'

export const subjectCommercialsItemMapper = (items: SubjectTableModel[]): SelectOption[] => {
  return items && items.map(commercialItemMapper)
}

export const commercialItemMapper = (item: SubjectTableModel): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.description
    }
  )
}

export const contractsListMapper = (items: ContractModel[]): SelectOption[] => {
  return items && items.map(contractsItemMapper)
}

export const contractsItemMapper = (item: ContractModel): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.contractCode
    }
  )
}

export const productFromcontractProductsListMapper = (
  items: ContractProductAPIModel[]
): SelectOption[] => {
  return items && items.map(productFromcontractProductsItemMapper)
}

export const productFromcontractProductsItemMapper = (
  item: ContractProductAPIModel
): SelectOption => {
  return (
    item && {
      value: item.productId,
      label: item.productCode
    }
  )
}

export const contractProductsListMapper = (items: ContractProductAPIModel[]): SelectOption[] => {
  return items && items.map(contractProductsItemMapper)
}

export const contractProductsItemMapper = (item: ContractProductAPIModel): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.productCode
    }
  )
}

export const commercialModelListToFormModelMapper = (
  items: CommercialModel[] | undefined
): CommercialFormModel[] => {
  return items ? items.map(commercialModelToFormModelMapper) : []
}

export const commercialModelToFormModelMapper = (item: CommercialModel): CommercialFormModel => {
  const relationLevel = enumEnumToValueNumber(EnumCommercialRelationActionType, item.relationLevel)
  return (
    item && {
      ...item,
      relationLevel: relationLevel ?? item.relationLevel,
      linkToAllContracts: relationLevel === EnumCommercialRelationActionType.Subject,
      linkToAllProducts: relationLevel === EnumCommercialRelationActionType.Contract,
      contractProductId:
        relationLevel === EnumCommercialRelationActionType.Contract ? 999 : item.contractProductId
    }
  )
}

export const commercialFormModelToPostRequestMapper = (
  item: CommercialFormModel
): NewCommercialModel => {
  const relationLevel = item.linkToAllContracts
    ? EnumCommercialRelationActionType.Subject
    : item.linkToAllProducts
    ? EnumCommercialRelationActionType.Contract
    : EnumCommercialRelationActionType.Product
  return (
    item && {
      commercialSubjectId: item.commercialSubjectId,
      contractId: item.contractId,
      productId: item.productId,
      subjectId: item.subjectId,
      contractProductId: item.contractProductId,
      relationLevel: relationLevel
    }
  )
}

export const commercialFormModelToUpdateRequestMapper = (
  item: CommercialFormModel
): CommercialModel => {
  const relationLevel = item.linkToAllContracts
    ? EnumCommercialRelationActionType.Subject
    : item.linkToAllProducts
    ? EnumCommercialRelationActionType.Contract
    : EnumCommercialRelationActionType.Product
  return (
    item && {
      id: item.id,
      commercialSubjectId: item.commercialSubjectId,
      contractId: item.contractId,
      productId: item.productId,
      subjectId: item.subjectId,
      contractProductId: item.contractProductId,
      relationLevel: relationLevel
    }
  )
}
